<template>
    <section>
        <header>
            <div class="map-items-location-filter">
                <ul
                    ref="location-filter"
                    v-click-outside="() => (showFilters = false)"
                    :class="{ active: showFilters }"
                >
                    <li
                        v-for="filter in sortedFilters"
                        :key="filter.index"
                        @click="setActiveFilter(filter.index)"
                    >
                        {{ filter.label }}
                    </li>
                </ul>
            </div>
            <img
                :src="areAllFilteredUsersHidden ? '/images/map/hidden.svg' : '/images/map/visible.svg'"
                @click="toggleVisibilityForFilteredUserLocations()"
            />
        </header>

        <ul
            v-if="filteredUserLocations.length"
            class="map-items-list"
        >
            <li
                v-for="userLocation in filteredUserLocations"
                :key="userLocation.gid"
                class="map-item"
            >
                <div>
                    <div>
                        <div class="map-item__gutter map-item__gutter--icon">
                            <img
                                :src="getUserIcon(userLocation)"
                                class="map-item__icon"
                                @click="$emit('selectUserLocation', $event, userLocation)"
                            />
                        </div>
                        <div class="map-item__identifier">
                            <p>{{ userLocation.getLabel() }}</p>
                            <span v-show="userLocation.isVisible()">
                                {{ userLocation.latitude }}, {{ userLocation.longitude }}
                            </span>
                        </div>

                        <map-item-controls
                            :isVisible="userLocation.isVisible()"
                            :mapItem="userLocation"
                            :clearMapObject="clearMapObject"
                            @set-visibility="toggleVisibility(userLocation)"
                            @locate-item="locateUser"
                        ></map-item-controls>
                    </div>
                </div>
            </li>
        </ul>
        <p
            v-else
            class="map-items-not-found"
        >
            No users available.
        </p>
    </section>
</template>

<script>
import * as _ from 'lodash'
import store from '@/store'
import MapItemControls from './MapItemControls.vue'

export default {
    components: {
        MapItemControls,
    },

    props: {
        userLocations: {
            type: Array,
            required: true,
        },

        clearMapObject: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            showFilters: false,
            filters: [
                {
                    index: 0,
                    label: 'All Users',
                    fn: (u) => u,
                },
                {
                    index: 1,
                    label: 'Active Users',
                    fn: (u) => !u.isStale() && !u.isInactive(),
                },
                {
                    index: 2,
                    label: 'Stale Users',
                    fn: (u) => u.isStale() && !u.isInactive(),
                },
                {
                    index: 3,
                    label: 'Inactive Users',
                    fn: (u) => u.isInactive(),
                },
            ],
            activeFilterIndex: 0,
        }
    },

    computed: {
        areAllFilteredUsersHidden() {
            const visible = (user) => user.isVisible()
            return !this.filteredUserLocations.some(visible)
        },

        sortedFilters() {
            const active = _.find(this.filters, (f) => f.index === this.activeFilterIndex)
            return [active, ...this.filters.filter((f) => f !== active)]
        },

        filteredUserLocations() {
            const filterBy = this.filters[this.activeFilterIndex].fn
            const filteredUserLocations = this.userLocations.filter(filterBy)
            const test = _.sortBy(filteredUserLocations, [
                (user) => user.isInactive(),
                (user) => user.isStale(),
                (user) => user.getLabel().toLowerCase(),
            ])

            return test
        },
    },

    mounted() {
        this.$eventBus.on('displayStaleUsers', () => {
            this.activeFilterIndex = 2
        })
    },

    methods: {
        toggleVisibilityForFilteredUserLocations() {
            const visible = this.areAllFilteredUsersHidden
            const userLocations = this.filteredUserLocations
            this.updateVisibilitySetting(visible, userLocations)
        },

        toggleVisibility(userLocation) {
            const visible = !userLocation.isVisible()
            this.updateVisibilitySetting(visible, [userLocation])
        },

        async updateVisibilitySetting(visible, userLocations) {
            await store.dispatch('mission/updateVisibilitySetting', {
                visible,
                userLocations,
            })
        },

        setActiveFilter(index) {
            if (this.showFilters) {
                this.activeFilterIndex = index
            }

            this.showFilters = !this.showFilters
        },

        getUserIcon(user) {
            return !user.isStale() && !user.isInactive()
                ? `/images/map/${user.getIcon()}.svg`
                : `/images/map/${user.getIcon()}-stale.svg`
        },

        locateUser(user) {
            if (user.latitude) {
                this.$eventBus.emit('centerOn', user)
            }
        },
    },
}
</script>
